import request from '@/utils/request'

export function getindexlist(data) { // 首页列表
  return request({
    url: '/backend/activity/distribution/getList',
    method: 'post',
    data: data
  })
}

export function createUpdate(data) { // 活动创建、编辑
  return request({
    url: '/backend/activity/distribution/createUpdate',
    method: 'post',
    data: data
  })
}
export function getDetail(data) { // 获取活动详情
  return request({
    url: '/backend/activity/distribution/getDetail',
    method: 'post',
    data: data
  })
}

export function updateStatus(data) { // 活动上下架
  return request({
    url: '/backend/activity/distribution/updateStatus',
    method: 'post',
    data: data
  })
}

export function getRelationshipList(data) { // 活动关联课程列表
  return request({
    url: '/backend/activity/distribution/getRelationshipList',
    method: 'post',
    data: data
  })
}

export function updateRelationshipStatus(data) { // 活动课程上下架
  return request({
    url: '/backend/activity/distribution/updateRelationshipStatus',
    method: 'post',
    data: data
  })
}

export function getVisitList(data) { // 查看今日打开人数
  return request({
    url: '/backend/activity/distribution/getVisitList',
    method: 'post',
    data: data
  })
}

export function getShareList(data) { // 查看今日分享人数
  return request({
    url: '/backend/activity/distribution/getShareList',
    method: 'post',
    data: data
  })
}

export function getOrderList(data) { // 分享页查下单列表、活动累计订单列表
  return request({
    url: '/backend/activity/distribution/getOrderList',
    method: 'post',
    data: data
  })
}

export function getOrderRebateList(data) { // 查看今日提现页面
  return request({
    url: '/backend/activity/distribution/getOrderRebateList',
    method: 'post',
    data: data
  })
}

export function createUpdateRelation(data) { // 查看今日提现页面
  return request({
    url: '/backend/activity/distribution/createUpdateRelation',
    method: 'post',
    data: data
  })
}

export function getRelationshipDetail(data) { // 查看今日提现页面
  return request({
    url: '/backend/activity/distribution/getRelationshipDetail',
    method: 'post',
    data: data
  })
}